<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'logs',
})
</script>
<template>
<a-card title="自定义页">
   <lanseed-form-only ref="form" :data="searchVal" :rules="searchRule" :mode="false" @change="search">
    <template  #btn>
        <a-form-item>
        <a-button type="primary" v-if="auth.creating>0" @click="add"><PlusOutlined /> 新增 </a-button>
      </a-form-item>
    </template>
  </lanseed-form-only>
  <lanseed-form v-model:open="formshow" :data="formModel" :rules="formRole"  @change="submit"></lanseed-form>
  <a-table rowKey="ID"  :row-selection="rowselection"  :columns="columns" :dataSource="dataSource" :pagination="page" :loading="loading" @change="pageChange">
    <template #title>
      <div v-if="rowselection.selectedRowKeys.length>0&&auth.del>0"  class="padding flex align-center" style="width: 100%;">
        <span class="text-gray">共选择了<span class="text-primary text-bold padding-lr-sm">{{ rowselection.selectedRowKeys.length }}</span>条数据</span>
        <a-button type="primary" size="small" class="margin-left" @click="onDel">
        <DeleteOutlined  />  删除</a-button>
      </div>
    </template>
    <template #bodyCell="{column,record,index}">
      <a v-if="column.dataIndex=='url'" target="_blank" :href="'/pages?id='+record.ID">/pages?id={{ record.ID }}</a>

      <a-button-group v-if="column.key=='action'">
            <a-button v-if="auth.edit>0" size="small" type="primary" @click="edit(record,index)">
                <EditOutlined /> 修改
            </a-button>
            <a-button v-if="auth.edit>0" size="small" type="primary" @click="openS(record,index)">
                <EditOutlined /> 内容
            </a-button>

          </a-button-group>
    </template>
  </a-table>
  <pageset ref="pagesets" ></pageset>
</a-card>
</template>
<script setup lang="ts" name="logs">
import api from '@/utils/http/service'
import { onMounted,ref,getCurrentInstance } from 'vue'
import {DeleteOutlined,PlusOutlined,EditOutlined} from   '@ant-design/icons-vue'
import LanseedFormOnly from '@/components/lanseed/formonly.vue'
import LanseedForm from '@/components/lanseed/form.vue'
import {message} from 'ant-design-vue'
import pageset from './pageset/index.vue'
import { reactive } from 'vue'
import {pagestyle}  from '@/utils/util'
const auth:any=api.auth()
const dataSource=ref<Array<any>>([])
const selectedIDS=ref<Array<any>>([])
const loading=ref<Boolean>(false)
const pagesets=ref()
const page=ref<Record<string,string>>({
  current:1,
  pageSize:10,
  total:0
})
const columns:Array<any>=[
  {title:'编号',dataIndex:'ID',width:100},
  {title:'名称',dataIndex:'title'},
  {title:'URL',dataIndex:'url'},
  {title:'操作',key:'action',},
]
const searchVal:Record=ref({
  keyword:''
})
const searchRule:Record=ref({
  keyword:{name:'关键字'},
})
const rowselection:any=ref({
  fixed:true,
  selectedRowKeys:[],
  onChange:(e:any)=>{
    rowselection.value.selectedRowKeys=e
  }
})
const formModel:Record=ref({})
const formRole=ref({
  title:{name:'标题',required:true},
  subtitle:{name:'描述'},
  classname:{name:'风格',domtype:'radio',data:pagestyle},
  orders:{domtype:'number',name:'排序'},
  contents:{domtype:'editor',name:'内容'},

})
const formshow=ref<Boolean>(false)
const getDataList=():void=>{
  loading.value = true
  api.sitepage.list({ pageIndex: page.value.current, pageSize: page.value.pageSize,...searchVal.value }).then(res => {
        loading.value = false
        if (res.state == 1) {
          let r = res.data
          page.value.current=r.pageIndex
          page.value.total=r.records
          dataSource.value = r.data
        }
      })
}
const search=(e):void=>{
  searchVal.value=e
  page.value.current=1
  getDataList()
}
const pageChange=(e):void=>{
  page.value.current=e.current
  page.value.pageSize=e.pageSize
  getDataList()
}
const onDel=(item:any,index:number):void=>{
  api.sitepage.dels(rowselection.value.selectedRowKeys).then(res => {
          if (res.state == 1) {
            message.success(res.message)
            getDataList()
          }
        })
}
const add=():void=>{
  formModel.value={ID:0,
    title:'',contents:'',subtitle:'',orders:0
  }
  formshow.value=true
}
const edit=(item,index):void=>{
  formModel.value=item
  formshow.value=true
}
const openS=(item,index):void=>{
  pagesets.value.open(item.ID)
}
const del=(item,index):void=>{
   api.sitepage.del(item.ID).then(res=>{
    if(res.state==1){
      dataSource.value.splice(index,1)
    }
   })
}
const submit=(e):void=>{
  api.sitepage.add(e).then(res=>{
    if(res.state==1){
      if(e.ID==0){
        dataSource.value.unshift(res.data)
      }else{
        let index =dataSource.value.findIndex(f=>{return f.ID==e.ID})
        dataSource.value[index]=res.data
      }
      formshow.value=false
      formModel.value=null
    }
  })
}
onMounted(()=>{
  getDataList()
})
</script>
